module.exports = __webpack_public_path__ + "img/instructor_img4.692c39ba.png";